import {
  ProgressResetApiRequestParam,
  ProgressResetApiResponseParam,
} from '../types/apis/progressResetApi';
import customAxios from '../utils/customAxios';

/**
 * トレーニング進捗リセットAPI呼び出し
 * @param reqParams リクエストパラメータ
 * @returns APIレスポンスのPromise
 */
const callProgressResetApi = (
  reqParams: ProgressResetApiRequestParam,
): Promise<ProgressResetApiResponseParam> => {
  const params = new URLSearchParams();
  params.append('accesskey', reqParams.accesskey);

  const response = customAxios
    .post<ProgressResetApiResponseParam>(
      `/superelmer-server/training/progress/reset`,
      params,
    )
    .then((res) => res.data);

  return response;
};
export default callProgressResetApi;
